<div class="row">
  <div class="col-12">
    <h1>Document Transfer</h1>
  </div>
</div>

<div id="sourceDetails" class="row">
  <div class="col-12">
    <h3>Document Source Details <a href="javascript:void(0)" (click)="editClicked()">Edit</a></h3>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Source Environment</dt>
      <dd>{{sourceEnvText}}</dd>
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Corporation</dt>
      <dd>{{sourceCorpText}}</dd>
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Facility</dt>
      {{sourceFacText}}
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Units Selected</dt>
      {{sourceUnits}}
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Document Types Selected</dt>
      {{sourceDocTypes}}
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Attached Date Range</dt>
      {{dateRange}}
    </dl>
  </div>
  <div class="col-12 col-sm-6 col-md-4">
    <dl>
      <dt>Residents Selected</dt>
      {{resCount}}
    </dl>
  </div>
</div>
<form [formGroup]="destinationForm">
<div class="card bg-light">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h3 class="mt-0">Documents Destination Details
          <div>
            <small>(Resident documents will be moved to new location as per selections made below)</small>
          </div>
        </h3>
      </div>
    </div>


    <div class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group input-required">
          <label for="destinationEnvironment">Destination Environment</label>
          <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="destinationEnvironment" id="destinationEnvironment"
                   [options]="destinationEnvironments" (onSelect)="getConversionCorporations()"></select2>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group input-required">
          <label for="destinationCorporation">Destination Corporation</label>
          <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="destinationCorporation" id="destinationCorporation"
                   [options]="destinationCorporations" (onSelect)="getConversionFacilities()"></select2>
        </div>
      </div>

      <div class="col-12 col-sm-6 col-md-4">
        <div class="form-group input-required">
          <label for="destinationFacility">Destination Facility</label>
          <select2 [settings]="{placeholder: 'Not Selected',width:'100%'}" formControlName="destinationFacility" id="destinationFacility"
                   [options]="destinationFacilities"></select2>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="row mt-1">
  <div class="col-12">
    <button class="btn btn-default" (click)="goBack()">Back</button>
    <button class="btn btn-success" (click)="openModal(docTransferReview); saveSessionDetails()" [disabled]="!destinationForm.valid" >Review Document Transfer</button>
  </div>
</div>


<ng-template #docTransferReview let-closeResult="close" let-dismissResult="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Document Transfer</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismissResult('Cross click'); removeSessionDetails(this.redisSessionId)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 col-sm-6">
        <dl class="dl-horizontal">
          <dt>Move Date/Time:</dt>
          <dd>{{confirmModalDateTime}}</dd>
        </dl>
      </div>
      <div class="col-12 col-sm-6">
        <dl class="dl-horizontal">
          <dt>Total Residents:</dt>
          <dd>{{resCount}}</dd>
        </dl>
      </div>
      <div class="col-12 col-sm-6">
        <dl class="dl-horizontal">
          <dt>Moved By:</dt>
          <dd>{{username}}</dd>
        </dl>
      </div>
      <div class="col-12">
        <dl class="dl-horizontal">
          <dt>Document Types:</dt>
          <dd>{{sourceDocTypes}}</dd>
        </dl>
      </div>
      <div class="col-12">
        <dl class="dl-horizontal">
          <dt>Attached Date Range:</dt>
          <dd>{{dateRange}}</dd>
        </dl>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <table class="table table-bordered table-striped mt-3">
          <thead>
            <tr>
              <th>Parameters</th>
              <th>Moving From</th>
              <th>Moving To</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Environment</td>
              <td>{{sourceEnvText}}</td>
              <td>{{confirmModalDestinaionEnvironment}}</td>
            </tr>
            <tr>
              <td>Corporation</td>
              <td>{{sourceCorpText}}</td>
              <td>{{confirmModalDestinaionCorporation}}</td>
            </tr>
            <tr>
              <td>Facility</td>
              <td>{{sourceFacText}}</td>
              <td>{{confirmModalDestinaionFacility}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-success" routerLink="/conversions/resident-doc-move" (click)="closeResult('Start Confirmed'); transferDocuments()">Confirm Document Transfer</button>
    <button type="button" class="btn btn-cancel" (click)="closeResult('Close click'); removeSessionDetails(this.redisSessionId)">Cancel</button>

  </div>
</ng-template>
</form>
